import {
  DiscountType,
  PackagedBeerDetailsContainer,
  PackagedBeerDetailsFragment,
  RecallType,
} from "../../../../gql/hooks";
import getContainerType from "./getContainerType";

const getCorrectProducts = (
  proposalAssortments?:
    | null
    | {
        productId: number;
        container?: PackagedBeerDetailsContainer | null | undefined;
      }[],
  commercialConditions?:
    | {
        packagedProductId: number;
        discountValue?: number | null;
        discountType?: DiscountType | null;
        recallValue?: number | null;
        recallType?: RecallType | null;
        amortizationValue?: number | null;
        amortizationType?: RecallType | null;
        packagedProductPrice: number;
        packagedProductUnitsNb: number;
        x?: number | null;
        y?: number | null;
        packagedProduct?: {
          productId: number;
          packagedDetails: PackagedBeerDetailsFragment | {};
        } | null;
      }[]
    | null
    | undefined,
  type?: PackagedBeerDetailsContainer,
) => {
  const assortmentsList = getContainerType(proposalAssortments, type);

  if (!commercialConditions) {
    return assortmentsList;
  }

  const commercialProducts = commercialConditions
    .map((productCC) => {
      if (
        (
          productCC.packagedProduct
            ?.packagedDetails as PackagedBeerDetailsFragment
        ).container === type
      ) {
        return productCC.packagedProduct?.productId || 0;
      }
      return 0;
    })
    .filter((_) => !!_);

  if (!assortmentsList.length) return commercialProducts;
  return assortmentsList.reduce((acc, item) => {
    if (!commercialProducts.includes(item)) {
      acc.push(item);
    }
    return acc;
  }, commercialProducts);
};

export default getCorrectProducts;
